import React from "react";
import UserContact from "../../components/contact/UserContact";

const UserContactPage = () => {
	return (
		<>
			<UserContact />
		</>
	);
};

export default UserContactPage;
